import React from "react";

interface SessionExpiredOverlayProps {
  open: boolean;
  onSignIn: () => void;
}

/**
 * Shown when the session really is over - the refresh token was rejected by the server.
 *
 * The point of this screen is that the user is told what happened. Redirecting straight to the
 * login page with no explanation reads as a random sign-out, which is what people report as
 * "the system logs me out on its own".
 */
const SessionExpiredOverlay: React.FC<SessionExpiredOverlayProps> = ({
  open,
  onSignIn,
}) => {
  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-gray-900/50 backdrop-blur-sm p-4">

      <div className="w-full max-w-md rounded-3xl border border-gray-100 bg-white p-8 shadow-2xl">

        <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50 text-amber-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-7 w-7"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.8}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
            />
          </svg>
        </div>

        <h2 className="text-2xl font-black uppercase tracking-tight text-gray-800">
          Session expired
        </h2>

        <p className="mt-3 text-sm leading-relaxed text-gray-500">
          Your session has ended. This usually means the account was signed in from another
          browser, or the security settings were changed while you were working. Sign in again
          to pick up where you left off.
        </p>

        <button
          type="button"
          onClick={onSignIn}
          className="mt-8 w-full rounded-xl bg-indigo-600 px-4 py-3 font-bold text-white shadow-lg shadow-indigo-100 transition-all hover:bg-indigo-700 active:scale-95"
        >
          Sign in again
        </button>

      </div>

    </div>
  );
};

export default SessionExpiredOverlay;
